import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    NavigationMenuTriggerColorsConstantType,
    NavigationMenuTriggerDynamicStyleType,
    NavigationMenuTriggerColors
} from "./type";
import {
    getTypeColors
} from "../../../../helpers/theme/typeColors";
import type {
    Mutable
} from "../../../../types";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    webStyle
} from "../../../../utils";

export const getNavigationMenuTriggerColors = ({
    isEmphasized,
    isDisabled,
    colors
}: NavigationMenuTriggerColorsConstantType): NavigationMenuTriggerColors => {
    const typeColors = getTypeColors({
        variant: "ghost",
        type: "neutral",
        isDisabled,
        colors
    });

    if(isDisabled) {
        return {
            indicatorColor: colors.system.state.content.disabled.neutral,
            borderColor: typeColors.borderColor,
            titleColor: typeColors.titleColor,
            iconColor: typeColors.iconColor
        };
    }

    return {
        titleColor: isEmphasized ? colors.content.text.high : colors.content.text.mid,
        iconColor: isEmphasized ? colors.content.icon.high : colors.content.icon.mid,
        indicatorColor: colors.content.text.high,
        borderColor: typeColors.borderColor
    };
};

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        alignItems: "center",
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    surface: {
        justifyContent: "center",
        borderStyle: "solid",
        alignItems: "center"
    },
    content: {
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center"
    },
    indicator: {
        pointerEvents: "none",
        position: "absolute"
    }
});

export const useStyles = ({
    currentMeasures,
    isFocusVisible,
    currentColors,
    shapeConfigs,
    isDisabled,
    barOffset,
    radiuses,
    borders,
    hitArea,
    colors,
    spaces
}: NavigationMenuTriggerDynamicStyleType) => {
    const styles = {
        surface: {
            paddingHorizontal: currentMeasures.paddingHorizontal,
            borderColor: currentColors.borderColor,
            minHeight: currentMeasures.minHeight,
            ...getCornerStyle({
                radius: radiuses.actions,
                shapeConfigs
            }),
            borderWidth: borders.line
        } as Mutable<ViewStyle>,
        indicator: {
            backgroundColor: currentColors.indicatorColor,
            start: currentMeasures.paddingHorizontal,
            end: currentMeasures.paddingHorizontal,
            bottom: -(barOffset + borders.line),
            height: borders.focus
        } as Mutable<ViewStyle>,
        container: {
            minHeight: hitArea.minHeight,
            minWidth: hitArea.minWidth
        } as Mutable<ViewStyle>,
        content: {
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>
    };

    Object.assign(styles.surface, getFocusRingStyle({
        isFocusVisible,
        borders,
        colors
    }));

    if(isDisabled) {
        Object.assign(styles.container, webStyle({
            cursor: "not-allowed"
        }));
    }

    return styles;
};
export default stylesheet;
